export enum REDEMPTION_TYPE_ID {
  DTL = 1,
  RESORT_TOOLS = 2,
}

export const RedemptionTypes = [
  '',
  'DTL',
  'Resort Tools',
];
